// removed by extract-text-webpack-plugin
module.exports = {"root":"_3S_ef","backdrop":"_1qdSr","active":"_2lxg6","content":"_2ZJHQ","close":"_1oB8F"};


//////////////////
// WEBPACK FOOTER
// ../source/components/Lightbox/styles.css
// module id = 1617
// module chunks = 6